<template>
  <div class="TalentSearch">
      <div class="search-content clear">
          
            <div class="search-request clear" v-if="talentFormApi.key">
                <div class="float-left border">关键词：{{talentFormApi.key}} <i class="icon-del" @click="delkey"></i></div>
                <p class="float-left">共找到<span>{{rowCount}}</span>门<span>“{{talentFormApi.key}}”</span>相关报告</p>
            </div>

            <div class="search-class">
                <search-type name="行业领域" :arrayList="typeList" v-model="talentFormApi.jobtypecode01" :active="talentFormApi.jobtypecode01" @searchclick="getSearchResult()"></search-type>
                <search-type name="行业细分" :arrayList="hyxfList" v-model="talentFormApi.jobtypecode02" :active="talentFormApi.jobtypecode02" @searchclick="getSearchResult()"></search-type>

                <search-type name="工作地点" :arrayList="gzddList" v-model="activeJobplace" :active="activeJobplace" @searchclick="selectJobplace"></search-type>
                <search-type name="薪资要求" :arrayList="xzyqList" v-model="activeAnnualSalary" :active="activeAnnualSalary" @searchclick="selectAnnualSalary"></search-type>
                
                <div v-if="acriveMenu == false">
                    <p class="el-icon-arrow-down more" @click="acriveMenu = true">展开更多选项</p>
                </div>
                <template v-if="acriveMenu == true">
                    <search-type name="学历要求" :arrayList="xlyqList" v-model="talentFormApi.edutype" :active="talentFormApi.edutype" @searchclick="getSearchResult()"></search-type>
                    <search-type name="工作经验" :arrayList="gzjyList" v-model="talentFormApi.exptype" :active="talentFormApi.exptype" @searchclick="getSearchResult()"></search-type>
                    <search-type name="企业性质" :arrayList="qyxzList" v-model="talentFormApi.companytype" :active="talentFormApi.companytype" @searchclick="getSearchResult()"></search-type>
                    <search-type name="发布时间" :arrayList="fbsjList" v-model="talentFormApi.timetype" :active="talentFormApi.timetype" @searchclick="getSearchResult()"></search-type>
                </template>
                <!-- 自定义组件 -->
            </div>


            <div class="search-main">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="最新发布" name="zxfb"></el-tab-pane>
                    <el-tab-pane label="薪酬最高" name="xczg"></el-tab-pane>
                </el-tabs>
                
                <div class="position-info">
                    <div class="null" v-if="talentlist.length === 0">
                        <img src="~common/images/search/search-null.png" alt="searchnull">
                        当前暂无招聘信息
                    </div>
                    <div class="position-info-item hastily" v-for="(item, index) in talentlist" :key="index" @click="gotoDetails(item.jobinnerid)">
                        <div class="card">
                            <p class="title">
                                <span class="position-name">{{item.jobname}}</span>
                                <span class="time">[{{item.lastupdatetime}}]</span>
                                <span class="year-money">{{item.salarytext}}</span>
                            </p>
                            <p class="company">{{item.companydisplayname}}</p>
                            <p class="msg-info">
                                <span>{{item.jobplace}}</span>
                                <span>{{item.industryname}}</span>
                                <span>{{item.exptypename}}</span>
                                <span class="moreinfo">查看详情</span>
                            </p>
                        </div>
                    </div>
                </div>

                <el-pagination background layout="prev, pager, next" :page-size="10" :current-page="talentFormApi.page" :total="rowCount"  @current-change="handleCurrentChange" v-if="talentlist.length > 0"></el-pagination>
                <!-- 分页 -->
            </div>
            <!-- 搜索主体 -->

            <div class="silde">
                <login-card></login-card>
                <!-- 登录 -->
                <slide-list :List="getRecommendJobList" label="热门高薪职位"></slide-list>
                <!-- 列表 -->
            </div>
            <!-- 搜索侧边栏 -->
      </div>
        <talent-button-silder></talent-button-silder>
        <!-- end talent-button-silder 猎聘侧边按钮栏 -->
  </div>
</template>

<script>
import $ from 'jquery'
import SearchType from './components/SearchItem'
import LoginCard from '../components/LoginCard'
import SlideList from '../components/SlideList'
import {mapActions, mapGetters} from 'vuex'
import cityList from '../components/cityList.json'
import type from '../components/type.json'
import YearMoneyType from '../components/YearMoneyType.json'
import TalentButtonSilder from '../components/TalentButtonSilder'
import {getSearchInfoByKey, getRecommendJob} from 'api/talent'

export default {
    name: "TalentSearch",
      data() {
        return {
            acriveMenu: false,  // 是否展开更多
            activeName: 'zxfb',
            typeList: [{name: '全部', code: '', list: []}, ...type], // 菜单列表 行业领域
            hyxfList: [], // 行业细分
            gzddList: [{name: '全部', code: '', list: []}, ...cityList], // 工作地点
            xzyqList: [{name: '全部', code: '', list: []}, ...YearMoneyType], // 薪资要求
            
            xlyqList: [{name:"全部", code: ""},{name:"本科以上", code: "1"},{name:"硕士以上", code: "2"}], // 学历要求
            gzjyList: [{name:"全部", code: ""},{name:"3年以下", code: "1"},{name:"3-5年", code: "2"},{name:"5-10年", code: "3"},{name:"10年以上", code: "4"}], // 工作经验
            qyxzList: [{name:"全部", code: ""},{name:"国企", code: "1"},{name:"民营企业", code: "2"},{name:"合资", code: "3"},{name:"外资（欧美）", code: "4"},{name:"外资（非欧美）", code: "5"},{name:"外企代表处", code: "6"}], // 企业性质
            fbsjList: [{name:"全部", code: ""},{name:"一天以内", code: "1"},{name:"三天以内", code: "2"},{name:"一周以内", code: "3"},{name:"一月以内", code: "4"}], // 发布时间

            talentlist: [], // 搜索列表
            getRecommendJobList: [], // 高薪职位列表

            activeJobplace: this.$route.query.jobplace ? this.$route.query.jobplace : '', // 选择城市
            activeAnnualSalary: this.$route.query.activeAnnualSalary ? this.$route.query.activeAnnualSalary : '', // 选择年薪

            talentFormApi: {
                key: this.$route.query.key ? decodeURI(this.$route.query.key) : '',   // 职位名称
                jobtypecode01: this.$route.query.jobtypecode01 ? this.$route.query.jobtypecode01 : '',  // 行业code 一级
                jobtypecode02: this.$route.query.jobtypecode02 ? this.$route.query.jobtypecode02 : '',  // 行业code 二级
                jobplace: '',   // 工作地点
                salarymin: '', // 薪资范围-最小值-单位万
                salarymax: '', // 薪资范围-最大值-单位万
                edutype: '', // 要求学历类型 1本科及以上 2硕士及以上
                companytype: '', // 企业类型 1 国企 2 民营企业 3 合资 4 外资（欧美） 5 外资（非欧美） 6 外企代表处
                timetype: '',   // 发布时间 时间类型:1 今天之内 2 三天以内 3 一周以内 4 一个月以内
                exptype: '', // 要求工作经验类型 0 不限 1-3年 2 3-5年 3 5-10年 4 10年以上
                searchtype: 1, // 排序类型 1 最新发布 2 薪酬最高
                page: 1,    // 页码
                pageSize: 10 // 每页记录数
            },
            rowCount: 0
        }
    },
    created() {

        // if(this.domainInfo.isMobile){
        //     let routerQuery = {
        //         catecode: this.$route.query.catecode,
        //         feetype: this.$route.query.feetype,
        //         reportyear: this.$route.query.reportyear

        //     }
        //     if (this.$route.query.isMobile && this.$route.query.isMobile == 1) {
        //         routerQuery.key = this.$route.query.data ? this.$route.query.data: ''
        //     } else {
        //         routerQuery.key = this.$route.query.data ? encodeURI(this.$route.query.data): ''
        //     }
            
        //     this.$router.push({
        //         name: 'MReportSearch',
        //         query: routerQuery
        //     })
        // }
    },
    mounted() {

        // 初始化菜单栏判断
        this.jobtypecodeTab()

        // 回到定点
        this._clearScrollTop()
        
        this.selectJobplace()
        this.selectAnnualSalary()

        this.getSearchResult(1)

        // 获取高薪职位
        this.initGetRecommendJob()

    },
    methods: {
        gotoDetails (jobid) {
            const {href} = this.$router.resolve({
                name: "JobInfo",
                query: {jobid: jobid}
            })
            window.open(href, '_blank')
        },
        jobtypecodeTab() {  // 菜单栏切换处理
            for (let i = 0; i < this.typeList.length; i++) {
                if (this.typeList[i].code == this.talentFormApi.jobtypecode01) {
                    this.hyxfList = [{code: '', name: '全部'}, ...this.typeList[i].list]
                    // 重置选项
                    this.talentFormApi.jobtypecode02 = ''
                }
            }
        },
        handleClick(name) { // 切换菜单栏事件
            if (name.name == 'zxfb') {
                this.talentFormApi.searchtype = 1
            } else {
                this.talentFormApi.searchtype = 2
            }
            this.getSearchResult()
        },
        initGetRecommendJob() { // 获取高薪职位
            this.setLoading(true)
            getRecommendJob({
                data: {searchtype: 1},
                success: data => {
                    this.setLoading(false)
                    this.getRecommendJobList = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        getSearchResult(page) { // 获取列表
            if (page) {
                this.talentFormApi.page = page
            } else {
                this.talentFormApi.page = 1
            }
            this.setLoading(true)
            getSearchInfoByKey({
                data: this.talentFormApi,
                success: data => {
                    this.setLoading(false)
                    this.talentlist = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                    // console.log(data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })

        },
        selectJobplace() {
            
            // 工作地点发生变化
            if (this.activeJobplace == '') {
                this.talentFormApi.jobplace = ''
            } else {
                for (let i = 0; i < cityList.length; i++) {
                    if (cityList[i].code == this.activeJobplace) {
                        this.talentFormApi.jobplace = cityList[i].name
                    }
                }
            }
            this.getSearchResult()
        },
        selectAnnualSalary() {
            // 薪资发生变化
            if (this.activeAnnualSalary == '') {
                this.talentFormApi.salarymin =  '' // 薪资范围-最小值-单位万
                this.talentFormApi.salarymax =  '' // 薪资范围-最大值-单位万
            } else {
                for (let i = 0; i < YearMoneyType.length; i++) {
                    if (YearMoneyType[i].code == this.activeAnnualSalary) {
                        this.talentFormApi.salarymin =  YearMoneyType[i].salarymin
                        this.talentFormApi.salarymax =  YearMoneyType[i].salarymax
                    }
                }
            }
            this.getSearchResult()
        },
        handleCurrentChange(val) { // 页数发生变化时触发
            // 页数发生变化，取得列表
            this.getSearchResult(val)
        },
        delkey() { // 清空选中关键词
            this.$router.push({name: 'TalentSearch'})
        },
        _JustTable() {  
            this.getCourseByKeyList()
        },
        _clearScrollTop() { // 初始化滚动条高度
            this.$nextTick(() => {
                $('html').scrollTop(0)
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        jobtypecode01() {
           // 初始化菜单栏切换
            this.jobtypecodeTab()
        },
        
        $route: {
            handler (val) { // val 更新的, oldVal 过去的
                
                this.talentFormApi.key = val.query.data
                // if (this.$route.query.catecode) {
                //     this.getCourseByKeyApi.catecode = this.$route.query.catecode
                // }
                this.getSearchResult(1)

                // this.getCategoryByKeyList()

            },
            // 深度观察监听
            deep: true
        }
    },
    computed: {
        jobtypecode01() {
            return this.talentFormApi.jobtypecode01
        },
        ...mapGetters(
            ['domainlist', 'domainInfo']
        )
    },
    components: {
        // StandardCourseCard
        SearchType,
        LoginCard,
        SlideList,
        TalentButtonSilder
    }
}
</script>

<style lang="scss" type="text/scss" >
.TalentSearch {
    .el-tabs__nav-wrap::after {
        height: 1px;
    }
    .standardCourseCard .title {
        font-size: 14px;
    }
    .el-tabs__nav-scroll {
        padding: 0 20px;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-tabs__item {
        height: 52px;
        line-height: 52px;
    }
    // margin-top: 80px;
    .el-menu {
        margin-bottom: 31px;
        .el-menu-item {
            font-size: 18px;
        }
        .el-menu-item.is-active {
            color: #409EFF !important;
        }
    }
    .more {
        width: 100%;
        color: #409EFF;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        height: 40px;
        border-top: solid 1px #eee;
        cursor: pointer;
    }
    .null {
        margin-top: 120px;
        margin-bottom: 180px;
        text-align: center;
        color: #CADAEE;
        font-size: 18px;

        img {
            margin: auto;
            margin-bottom: 26px;
            width: 234px;
            height: 121px;
        }
    }
    .icon-del {
        display: inline-block;
        width: 10px;
        height: 10px;
        cursor: pointer;
        background: url('../../../common/images/search/del.png');
        background-size: 10px;
    }
    .search-content {
        margin: auto;
        margin-bottom: 20px;
        /*padding-top: 30px;*/
        width: 1180px;

        .search-request {
            margin-bottom: 20px;
            .border {
                padding: 0 8px;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                border: dashed  1px #409EFF;
            }
            p {
                margin-left: 30px;
                line-height: 28px;
                font-size: 14px;

                span {
                    display: inline-block;
                    padding:  0 5px;
                    color: #409EFF
                }
            }
        }

        .search-class {
            // margin-top: 20px;
            padding: 0 20px;
            overflow: hidden;
            background:rgba(255,255,255,1);
            // box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);
            border: solid 1px #eee;

            .SearchItem:first-child .item {
                border: none;
            }
        }
        
        .search-main {
            margin-top: 20px;
            min-height: 500px;
            .search-list {
                margin: 0 -20px 0 0;
            }
            
        }
        
        .el-pagination {
            margin-top: 20px;
            margin-bottom: 45px;
            text-align: center
        }
        .search-main {
            float: left;
            width: 865px;
            overflow: hidden;
            background: #fff;
        }
        .position-info {
            overflow: hidden;
            .position-info-item {
                position: relative;
                float: left;
                box-sizing: border-box;
                width: 100%;
                height: 137px;
                background:rgba(255,255,255,1);

                &:hover {
                    background:rgba(245,249,255,1);
                }

            .card {
                position: absolute;
                padding: 24px 0;
                margin: 0 20px;
                box-sizing: border-box;
                width: calc(100% - 40px);
                height: 137px;
                border-bottom: 1px dashed rgba(229,229,229,1);
                transition: all .5s;
                -webkit-transition: all .5s;
                -ms-transition: all .5s;
                -moz-transition: all .5s;
                -o-transition: all .5s;
                cursor: pointer;

                .title {
                height: 22px;
                line-height: 22px;
                span {
                    float: left;
                }
                .position-name {
                    font-size: 16px;
                    color: #2E7FFF;
                }
                .time {
                    margin-left: 6px;
                    font-size: 14px;
                    color: #999;
                }
                .year-money {
                    margin-left: 27px;
                    font-size: 16px;
                    color: #FF7F04;
                }
                }
                .company {
                    margin-top: 10px;
                    margin-bottom: 15px;
                    color: #666666;
                    font-size: 14px;
                }
                .hr {
                display: block;
                margin: 12px 0 17px 0;
                height: 1px;
                width: 100%;
                background: #e5e5e5;
                }

                .msg-info {
                span {
                    float: left;
                    margin-top: 6px;
                    padding: 0 20px;
                    color: #666666;
                    font-size: 14px;
                    border-left: 1px #E5E5E5 solid;
                    &:nth-child(1) {
                    padding-left: 0;
                    border-left: none;
                    }
                }
                .moreinfo {
                    position: absolute;
                    margin: auto;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    padding: 0;
                    width: 102px;
                    height: 34px;
                    line-height: 34px;
                    text-align: center;
                    font-size: 14px;
                    color: #2E7FFF;
                    box-sizing: border-box;
                    background:rgba(255,255,255,1);
                    border-radius:2px;
                    border:1px solid rgba(46,127,255,1);

                }
                }
            }

            }

        }
    }
}
</style>